import React, { useState, useEffect, useRef } from 'react';

import EditModalShell from '../forms/EditModalShell/EditModalShell';
import LoadingModal from '../LoadingModal/LoadingModal';
import AdminProgressBar from '../../AdminProgressBar/AdminProgressBar';
import FormField from '../forms/FormField/FormField';

import './BlogPostCategoryModal.css';

const BlogPostCategoryModal = ({
  onClose,
  onSubmit,
  blogPostCategory,
  mode,
  errorMsg,
}) => {
  const initialFormState = {
    name: '',
    description: '',
    showOnBlogSideBar: false,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const { name, description, showOnBlogSideBar } = formData;

  const firstInputRef = useRef();

  /* ---------- Init ---------- */

  useEffect(() => {
    setFormData({
      name: blogPostCategory?.name || '',
      description: blogPostCategory?.description || '',
      showOnBlogSideBar: blogPostCategory?.showOnBlogSideBar || false,
    });

    firstInputRef.current?.focus();
  }, [mode, blogPostCategory]);

  /* ---------- Handlers ---------- */

  const handleInputChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCheckboxChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  };

  /* ---------- Submit ---------- */

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setProgress(0);

    try {
      const finalData = { ...formData };

      setProgress(100);

      await onSubmit(finalData);
    } catch (err) {
      console.error(err);
      alert('Upload failed.');
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  /* ---------- Render ---------- */

  return (
    <EditModalShell
      formId='blog-post-category-modal-form'
      onClose={onClose}
      onSubmit={handleSubmit}
      mode={mode}
      isLoading={loading}
      itemLabel='Category'
    >
      {loading && (
        <LoadingModal>
          <AdminProgressBar progress={progress} message='Saving' />
        </LoadingModal>
      )}

      <div className='blog-post-category-modal-content-container'>
        <div className='blog-post-category-modal-pages-container'>
          <div className='blog-post-category-modal-blog-page-container'>
            <div className='blog-post-category-model-error-container'>
              {errorMsg && <span>{errorMsg} </span>}
            </div>

            <FormField
              type='text'
              name='name'
              label='Name'
              value={name}
              onChange={handleInputChange}
              ref={firstInputRef}
              required
            />

            <FormField
              type='textarea'
              name='description'
              label='Description'
              value={description}
              onChange={handleInputChange}
            />

            <FormField
              type='checkbox'
              name='showOnBlogSideBar'
              label='Show on Blog Side Bar'
              value={showOnBlogSideBar}
              onChange={handleCheckboxChange}
            />
          </div>
        </div>
      </div>
    </EditModalShell>
  );
};

export default BlogPostCategoryModal;
